<template>
  <v-layout>
    <v-app-bar :height="54" :elevation="1" :style="{ backgroundColor: primaryColor }">
      <template #prepend>
        <v-app-bar-nav-icon
          rounded="rounded-circle"
          size="40"
          @click="navActive = !navActive"
          style="margin-left: 14px"
        >
          <v-icon :icon="navActive ? 'mdi-menu-open' : 'mdi-menu'" size="30"></v-icon>
        </v-app-bar-nav-icon>
      </template>
      <template #title>
        <v-app-bar-title> {{ customerName }} </v-app-bar-title>
      </template>
    </v-app-bar>
    <v-navigation-drawer
      :model-value="navActive"
      location="left"
      width="300"
      elevation="5"
      :style="{
        marginTop: '0px',
        backgroundColor: drawerBg,
        position: 'fixed'
      }"
      @update:model-value="navActive = false"
    >
      <v-list>
        <v-tooltip v-for="item in navItems" :key="item.name" location="right" :text="item.name">
            <template #activator="{ props: tooltipProps }">
              <div v-bind="tooltipProps">
                <v-list-item @click="goTo(item.route)">
                  <template #title>
                    <v-btn
                      variant="flat"
                      style="margin-left: 18px; background-color: transparent; pointer-events: none"
                    >
                      <v-icon size="30" :color="isActive(item.route) ? 'var(--primary-color)' : '#000'">
                        {{ item.icon }}
                      </v-icon>
                      {{ item.name }}
                    </v-btn>
                  </template>
                </v-list-item>
              </div>
            </template>
          </v-tooltip>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <RouterView />
    </v-main>
    <LoginDialog />
  </v-layout>
</template>

<script>
import { inject, computed } from 'vue'
import LoginDialog from '@/components/shared/dialogs/LoginDialog.vue'

export default {
  components: {
    LoginDialog
  },
  setup() {
    const config = inject('config', { customerName: 'App', theme: {} })

    const primaryColor = computed(() => config?.theme?.primaryColor || '#1976D2') // Vuetify-Default-Farbe als Fallback
    const customerName = computed(() => config?.customerName || 'Eventmanagement')
    const drawerBg = computed(() => '#f5f5f5') // oder primaryColor.value

    return { config: config, primaryColor, customerName, drawerBg }
  },
  data() {
    return {
      navActive: false,
      navItems: [
      {
          name: 'Veranstaltungen',
          icon: 'mdi-calendar',
          route: '/event'
        },
        {
          name: 'Lager',
          icon: 'mdi-store-outline',
          route: '/storage'
        },
        {
          name: 'Materialien',
          icon: 'mdi-tools',
          route: '/material'
        },
        {
          name: 'Admin',
          icon: 'mdi-cogs',
          route: '/admin'
        }
      ],
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    goTo(route) {
      this.$router.push(route)
    },
    isActive(route) {
      return this.$route.path.includes(route)
    }
  }
}
</script>

<style scoped>
nav {
  text-align: left;
  margin-left: -1rem;
  font-size: 1rem;

  padding: 1rem 0;
  margin-top: 1rem;
}
</style>
